import React, { FC, useState } from "react";
import { connect } from "react-redux";
import { PrimaryButton, TextField } from "office-ui-fabric-react";
import { State } from "../../store";
import { mergeStyles, MessageBar, MessageBarType } from "@fluentui/react";
import { useHistory } from "react-router-dom";
import * as GeneralStore from "../../store/GeneralStore";

type Props = GeneralStore.GeneralState;

const buttonIcon = mergeStyles({
  padding: "9px 10px",
  fontSize: 14,
  fontWeight: 700,
  // height: 40,
  // width: 40,
  justifyContent: "center",
  border: "1px solid var(--primary-500)",
  display: "flex",
  alignItems: "center",
  color: "var(--white-000)",
  background: "var(--primary-500)",
  borderRadius: 4,
  selectors: {
    [":active"]: {
      backgroundColor: "var(--primary-500)"
    }
  }
});

const whitelist = [
  "david.customer@qad.com",
  "debbie.customer@qad.com",
  "amy.customer@qad.com",
  "dom.customer@qad.com",
  "dev.customer@qad.com"
];
const CustomerLoginPage: FC<Props> = (props: Props) => {
  const history = useHistory();
  const [username, setUsername] = useState<string>();
  const [errorMessage, setErrorMessage] = useState<string>();
  const [isLoading, setIsLoading] = useState(false);

  const onLogin = () => {
    setIsLoading(true);
    setErrorMessage(undefined);

    setTimeout(() => {
      if (
        username &&
        whitelist.indexOf(username?.trim().toLowerCase() ?? "") >= 0
      ) {
        history.push("/customer");
        history.go(0);
      } else {
        setErrorMessage("Username and password did not match.");
      }
      setIsLoading(false);
    }, 1500);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minWidth: "100vw",
        minHeight: "100vh"
      }}
    >
      <div
        style={{
          display: "flex",
          gap: 15,
          alignItems: "center",
          padding: 24,
          borderBottom: "1px solid #D9D9D9"
        }}
      >
        <img src="/logo-white.svg" alt="" />
        <div
          style={{
            width: 1,
            height: 28,
            background: "#2D3030",
            opacity: 0.3
          }}
        ></div>
        <span style={{ fontWeight: "bolder", fontSize: 24 }}>
          Customer Portal
        </span>
      </div>
      <div
        style={{
          flexGrow: 1,
          background: "url(/bg-image.svg)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "bottom",
          display: "grid"
        }}
      >
        <div
          style={{
            width: 448,
            height: 293,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 10,
            background: "#FFF",
            borderRadius: 8,
            placeSelf: "center",
            justifyContent: "center",
            boxShadow: "4px 4px 24px 0px rgba(0, 0, 0, 0.10)"
          }}
        >
          <span
            style={{
              fontWeight: "bolder",
              fontSize: 24
            }}
          >
            Welcome Back.
          </span>

          <div className="ms-Grid-row" style={{ padding: "2px 20px" }}>
            <div className="ms-Grid-col ms-md6">
              <div style={{ width: 300 }}>
                <TextField
                  id="txt-username"
                  placeholder="Username"
                  iconProps={{ iconName: "ProfileSearch" }}
                  disabled={isLoading}
                  required
                  value={username}
                  onChange={(e, newValue) => setUsername(newValue)}
                  styles={{
                    fieldGroup: { height: "42px", border: "1px solid #D8DFE6" },
                    icon: {
                      lineHeight: "36px",
                      height: "40px",
                      width: "39px",
                      textAlign: "center",
                      background: "#EDEDED",
                      bottom: "0",
                      right: "0",
                      color: "#4C4C4C"
                    }
                  }}
                />
              </div>
            </div>
            <div className="ms-Grid-col ms-md6">
              <div style={{ width: 300, marginTop: 10 }}>
                <TextField
                  id="txt-password"
                  type="password"
                  placeholder="Password"
                  required
                  iconProps={{ iconName: "AzureKeyVault" }}
                  disabled={isLoading}
                  styles={{
                    fieldGroup: { height: "42px", border: "1px solid #D8DFE6" },
                    icon: {
                      lineHeight: "36px",
                      height: "40px",
                      width: "39px",
                      textAlign: "center",
                      background: "#EDEDED",
                      bottom: "0",
                      right: "0",
                      color: "#4C4C4C"
                    }
                  }}
                />
              </div>
            </div>
            <div className="ms-Grid-col ms-md12">
              <div style={{ marginTop: 10, height: 32 }}>
                {errorMessage && (
                  <MessageBar
                    messageBarType={MessageBarType.error}
                    isMultiline={true}
                  >
                    {errorMessage}
                  </MessageBar>
                )}
              </div>
            </div>
          </div>

          <div>
            <PrimaryButton
              className={buttonIcon}
              text="Customer Email Account"
              iconProps={{ iconName: "FollowUser" }}
              onClick={onLogin}
              disabled={isLoading}
              styles={{
                textContainer: {
                  flexGrow: "0"
                },
                root: {
                  width: "295px",
                  height: "48px"
                }
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect((state: State) => state.general)(
  CustomerLoginPage as any
);
